export class PrivateValueStore {}
//# sourceMappingURL=types.js.map